module.exports = __webpack_public_path__ + "img/columna-naranco-especifica-alteracion.2d01c874.png";